"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _hooks = require("../../../hooks");
var _ListItem = _interopRequireDefault(require("../../../../ListItem"));
var _Select = _interopRequireDefault(require("../../../../Select"));
var _usePrevious = _interopRequireDefault(require("../../../../../hooks/usePrevious"));
var _react = require("react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __spreadArray = void 0 && (void 0).__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var Select = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
    disabled = props.disabled,
    isMultiSelect = props.isMultiSelect,
    name = props.name,
    onSelect = props.onSelect,
    options = props.options,
    selectProps = __rest(props, ["children", "disabled", "isMultiSelect", "name", "onSelect", "options"]);
  var _a = (0, _hooks.useInputLogic)({
      defaultValue: "",
      disabled: disabled,
      name: name
    }),
    clearValidationMessages = _a.clearValidationMessages,
    disabledCombined = _a.disabled,
    onBlur = _a.onBlur,
    setFieldValue = _a.setFieldValue,
    value = _a.value;
  var previousValue = (0, _usePrevious.default)(value);
  var onChange = (0, _react.useCallback)(function (option) {
    var currentValue = value && typeof value === "string" ? value.split("~") : [];
    var newValue;
    if (currentValue.includes(option)) {
      newValue = currentValue.filter(function (currentOption) {
        return currentOption !== option;
      }).join("~");
    } else {
      if (isMultiSelect) {
        newValue = __spreadArray(__spreadArray([], currentValue, true), [option], false).join("~");
      } else {
        newValue = option;
      }
    }
    setFieldValue(name, newValue);
    clearValidationMessages(name);
    if (onSelect) {
      onSelect(option);
    }
  }, [clearValidationMessages, isMultiSelect, name, onSelect, setFieldValue, value]);
  (0, _react.useEffect)(function () {
    if (previousValue !== value) {
      onBlur();
    }
  }, [previousValue, onBlur, value]);
  var selected = String(value).split("~").map(function (value) {
    var _a;
    var option = (_a = options.filter(function (option) {
      return option.value === value;
    })) === null || _a === void 0 ? void 0 : _a[0];
    return !option ? undefined : {
      label: option.text,
      value: option.value
    };
  }).filter(Boolean);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_Select.default, __assign({
      ref: ref,
      isMultiSelect: isMultiSelect
    }, selectProps, {
      disabled: disabledCombined,
      onSelect: onChange,
      selected: selected
    }, {
      children: options.map(function (option) {
        return (0, _jsxRuntime.jsx)(_ListItem.default, __assign({}, option), option.value);
      })
    })), children]
  });
});
var _default = Select;
exports.default = _default;